module.exports = __webpack_public_path__ + "img/z (31).68fe9d86.png";